// extracted by mini-css-extract-plugin
export default {"startTimerSection":"OnlineStartTimer_startTimerSection__K7vrW","time":"OnlineStartTimer_time__7XKcp","pulse":"OnlineStartTimer_pulse__MtjE7"};